import React from "react";

const PageTitle = ({ children }) => {
  return <div className="text-2xl font-bold mb-6">{children}</div>;
};

export default PageTitle;
